import React,{Component} from 'react';
import ListSubheader from 'material-ui/List/ListSubheader';
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import { getJSON } from 'jquery'
import { CircularProgress } from 'material-ui/Progress';
class NewArticle extends Component{

constructor(){
    super();
    this.state={
        load:false,
        contextArray:[]
    }
}

    componentWillMount(){
        this.setState({
            load:true
        })
        getJSON('http://123.207.90.121:8080/newBlog/api/getContextsByDate').then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.setState({
                    contextArray:data
                })
                console.log("加载context成功"+data.length)
            }else {
                this.handleLoginError();
                console.log("加载context失败")
            }
            return true;
        },error=> {
        }).then(flag=>{
                this.setState({
                    load:false,
                })
        })
        }



    render(){

        if (this.state.load){
            return (<table valign="medium" align="center" style={{width:'100%'}}>
                <tbody><tr><td align="center"><CircularProgress style={{color:'green'}} />
                </td></tr></tbody></table>)
        }

        return (
            <Paper style={{background:'white'}}>
                <Divider />
                <List  component="nav"  subheader={<ListSubheader  component="div">New Article</ListSubheader>}>
                    <Divider />
                    {this.state.contextArray.map((context)=>{
                        return(
                            <ListItem  key={context.contextId}>
                                <table width="100%"><tbody><tr><td><ListItemText primary={context.contextTitle} /></td></tr>
                                <tr>
                                    <td align="left">
                                        <span  style={{fontSize:'10px',color:'green'}}>{context.contextTime.substring(0,10)}</span>
                                    </td>
                                </tr>
                                </tbody></table>

                            </ListItem>
                        )
                    })}



                </List>

            </Paper>
        )
    }

}
export default NewArticle;


// WEBPACK FOOTER //
// ./src/Compent/page/NewArticle.js